<template>
  <div class="popUpWrap">
    <section class="popup dark basic">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close" />
      </div>
      <div class="scrollY">
        <div class="textArea flex">
          <h5>{{ t('organization-member-delete-title') }}</h5>
        </div>
        <div class="btnArea">
          <button class="cancel" @click.stop="dialogStore.close">
            {{ t('common-cancel') }}
          </button>
          <button type="button" @click.stop="onClickDelete">{{ t('common-delete') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import {useToastStore} from '~/store/toast/toastStore';
import {useOrganizationService} from '~/composables/service/useOrganizationService';
import {ToastType} from '~/components/Common/Toast/model/ToastType';

const { t } = useI18n();
const dialogStore = useDialogStore();
const toastStore = useToastStore();
const organizationService = useOrganizationService();

const onClickDelete = () => {
  const uuid = dialogStore.options.props.uuid;
  organizationService.deleteOrganizationMember([uuid]).then(() => {
    toastStore.openToast({
      toastType: ToastType.SUCCESS,
      contents: t('organization-member-delete-success'),
    })
    dialogStore.options.confirm?.event();
  }).catch(() => {
    toastStore.openToast({
      toastType: ToastType.FAILED,
      contents: t('organization-member-delete-fail'),
    })
  }).finally(() => dialogStore.close())
}
</script>
